<div class="container">
    <div class="mt-4 mb-4 mx-5">
        <div class="card p-3 m-5">
            <div class="status">{{status}}</div>
            <p>{{message}}</p>
        </div>
    </div>
</div>
